// AudioUploader.js
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export async function uploadAudioBlob({ arenaId, messageId, blob }) {
  if (!arenaId || !messageId || !blob) throw new Error('Missing params');
  const storage = getStorage();
  const path = `audioMessages/${arenaId}/${messageId}.webm`;
  const audioRef = ref(storage, path);
  await uploadBytes(audioRef, blob);
  return await getDownloadURL(audioRef);
}
